/* unplugin-vue-components disabled */import script from "./MessageDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDetails.vue?vue&type=script&setup=true&lang=js"

import "./MessageDetails.vue?vue&type=style&index=0&id=658821fd&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658821fd"]])

export default __exports__